"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheKeys = exports.ConnectionStatus = exports.MessageSubject = exports.ProductName = exports.LotStatus = exports.AuctionTypeEnum = exports.DocumentTypeEnum = exports.FileExportType = void 0;
var FileExportType;
(function (FileExportType) {
    FileExportType[FileExportType["CSV"] = 0] = "CSV";
    FileExportType[FileExportType["PDF"] = 1] = "PDF";
})(FileExportType || (exports.FileExportType = FileExportType = {}));
var DocumentTypeEnum;
(function (DocumentTypeEnum) {
    DocumentTypeEnum[DocumentTypeEnum["Lot"] = 0] = "Lot";
    DocumentTypeEnum[DocumentTypeEnum["IndividualProfile"] = 1] = "IndividualProfile";
    DocumentTypeEnum[DocumentTypeEnum["CompanyProfile"] = 2] = "CompanyProfile";
    DocumentTypeEnum[DocumentTypeEnum["Auction"] = 3] = "Auction";
})(DocumentTypeEnum || (exports.DocumentTypeEnum = DocumentTypeEnum = {}));
var AuctionTypeEnum;
(function (AuctionTypeEnum) {
    AuctionTypeEnum[AuctionTypeEnum["Timed"] = 0] = "Timed";
    AuctionTypeEnum[AuctionTypeEnum["Streamed"] = 1] = "Streamed";
    AuctionTypeEnum[AuctionTypeEnum["Tender"] = 2] = "Tender";
})(AuctionTypeEnum || (exports.AuctionTypeEnum = AuctionTypeEnum = {}));
var LotStatus;
(function (LotStatus) {
    LotStatus["AWAITING"] = "AWAITING";
    LotStatus["STARTED"] = "STARTED";
    LotStatus["COMPLETED"] = "COMPLETED";
})(LotStatus || (exports.LotStatus = LotStatus = {}));
var ProductName;
(function (ProductName) {
    ProductName["PremAssets"] = "PremAssets";
    ProductName["PremProperty"] = "PremProperty";
    ProductName["PremWheels"] = "PremWheels";
    ProductName["PremBid"] = "PremBid";
})(ProductName || (exports.ProductName = ProductName = {}));
var MessageSubject;
(function (MessageSubject) {
    MessageSubject["LotBidExtension"] = "LotBidExtension";
    MessageSubject["WonLot"] = "WonLot";
    MessageSubject["MaximumBidAmountReached"] = "MaximumBidAmountReached";
    MessageSubject["Outbid"] = "Outbid";
    MessageSubject["RegisteredProfileApproved"] = "RegisteredProfileApproved";
    MessageSubject["RegisteredProfileDeclined"] = "RegisteredProfileDeclined";
    MessageSubject["AuctionStarted"] = "AuctionStarted";
    MessageSubject["PreAuctionEnds"] = "PreAuctionEnds";
    MessageSubject["PreAuctionStarts"] = "PreAuctionStarts";
    MessageSubject["AuctionDatesUpdated"] = "AuctionDatesUpdated";
    MessageSubject["RegisteredProfileNotRegistered"] = "RegisteredProfileNotRegistered";
    MessageSubject["RequestMissingDocuments"] = "RequestMissingDocuments";
    MessageSubject["UpdateRegisteredProfile"] = "UpdateRegisteredProfile";
    MessageSubject["BidUpdated"] = "BidUpdated";
    MessageSubject["CreateBid"] = "CreateBid";
    MessageSubject["UpdatedStartPrice"] = "UpdatedStartPrice";
    MessageSubject["UpdatedReservePrice"] = "UpdatedReservePrice";
    MessageSubject["ManuallyExtendedLot"] = "ManuallyExtendedLot";
    MessageSubject["UpdateLotIncrement"] = "UpdateLotIncrement";
    MessageSubject["EntityLocked"] = "EntityLocked";
    MessageSubject["EntityReleased"] = "EntityReleased";
})(MessageSubject || (exports.MessageSubject = MessageSubject = {}));
var ConnectionStatus;
(function (ConnectionStatus) {
    ConnectionStatus["Connecting"] = "Connecting";
    ConnectionStatus["Connected"] = "Connected";
    ConnectionStatus["ReConnecting"] = "ReConnecting";
    ConnectionStatus["Disconnected"] = "Disconnected";
    ConnectionStatus["Error"] = "Error";
    ConnectionStatus["Unauthorized"] = "Unauthorized";
    ConnectionStatus["TimedOut"] = "TimedOut";
})(ConnectionStatus || (exports.ConnectionStatus = ConnectionStatus = {}));
var CacheKeys;
(function (CacheKeys) {
    CacheKeys["auction"] = "auction";
    CacheKeys["lot"] = "lot";
    CacheKeys["biddingData"] = "biddingData";
    CacheKeys["registrationStatus"] = "registrationStatus";
})(CacheKeys || (exports.CacheKeys = CacheKeys = {}));
